import React, { useEffect, useState } from "react";
import "./SkuDeliveryFilter.scss";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { formatDate } from "../../utils/Helper";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { FilterOptionSchema } from "../Filter/filter.data";
import dayjs from "dayjs";
import Filter from "../Filter/Filter";
import AddressDropdown from "../AddressDropdown/AddressDropdown";
import { useSelector } from "react-redux";
import { getUserWarehouseAddresses } from "../../redux/user/userSelector";
import { UserAddress } from "../../redux/user/userTypes";
import ApiService from "../../services/apiService";
import URLS from "../../urls/Urls";

interface SkuPricingProps {
  startDate: Date;
  endDate: Date;
  startDateSelected: (date: Date) => void;
  endDateSelected: (date: Date) => void;
  selectedDeliveryType: string;
  toggleSelectedDeliveryType: (val: string) => void;
  selectedVendor: FilterOptionSchema[];
  vendorFilter: (value: FilterOptionSchema[]) => void;
  selectedAddress: UserAddress | null;
  setSelectedAddress: (address: UserAddress | null) => void;
  skuAddresses: number[];
}

const SkuDeliveryFilter: React.FC<SkuPricingProps> = ({
  startDate,
  endDate,
  startDateSelected,
  endDateSelected,
  selectedDeliveryType,
  toggleSelectedDeliveryType,
  selectedVendor,
  vendorFilter,
  selectedAddress,
  setSelectedAddress,
  skuAddresses,
}) => {
  const [startDateOpen, setStartDateOpen] = useState<boolean>(false);
  const [endDateOpen, setEndDateOpen] = useState<boolean>(false);
  const [vendors, setVendors] = useState<FilterOptionSchema[]>([]);
  const userWarehouses = useSelector(getUserWarehouseAddresses);
  const [skuAddressList, setSkuAddressList] = useState<UserAddress[]>([]);

  useEffect(() => {
    setSkuAddressList(
      userWarehouses.filter((row) => skuAddresses.indexOf(row.id) > -1),
    );
  }, [skuAddresses]);

  useEffect(() => {
    getVendors();
  }, []);

  const startDateSelecttion = (event: any) => {
    startDateSelected(event.toDate());
    toggleStartDate();
  };

  const endDateSelection = (event: any) => {
    endDateSelected(event.toDate());
    toggleEndDate();
  };

  const toggleStartDate = () => {
    setStartDateOpen((val) => !val);
  };

  const toggleEndDate = () => {
    setEndDateOpen((val) => !val);
  };

  const getVendors = async () => {
    try {
      const { data } = await ApiService().client.get(
        URLS.VENDORS.FETCH_VENDOR_LIST,
      );
      if (data.vendors) {
        setVendors(data.vendors);
      }
    } catch (e) {
      console.error("Error: ", e);
    }
  };

  return (
    <div className="sku-delivery-filter-container flex-column full-width">
      <div className="ds-header flex-row align-items-center justify-content-space-between">
        <div className="delivery-calendar-status-main-container flex-row justify-content-space-between">
          <div className="ds-status-tabs-container flex-row align-items-center gap-4">
            <span
              className={`ds-status-tab xetgo-font-tag bold px-12 py-4 ${
                selectedDeliveryType === "Overdue" && "active-tab"
              }`}
              onClick={() => toggleSelectedDeliveryType("Overdue")}
            >
              Overdue
            </span>
            <span
              className={`ds-status-tab xetgo-font-tag bold px-12 py-4 ${
                selectedDeliveryType === "Due" && "active-tab"
              }`}
              onClick={() => toggleSelectedDeliveryType("Due")}
            >
              Due
            </span>
            <span
              className={`ds-status-tab xetgo-font-tag bold px-12 py-4 ${
                selectedDeliveryType === "Delivered" && "active-tab"
              }`}
              onClick={() => toggleSelectedDeliveryType("Delivered")}
            >
              Delivered
            </span>
          </div>
        </div>

        <div className="ds-filters flex-row align-items-center gap-16">
          <img
            className="delivery-calendar-filter-icon"
            src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20231010064729-grey_filter.svg"
            alt="filter-icon"
            height={19}
            width={19}
          />
          <div className="delivery-calendar-multi-filter-box  gap-8">
            <Filter
              option={{ key: "vendor", name: "Vendor" }}
              optionList={vendors}
              multipleSelection={false}
              onSelection={(val, _option) => {
                vendorFilter(val);
              }}
              showPlaceholder={true}
              mode="showNames"
              addNew={false}
              showId={false}
              preSelected={selectedVendor}
              classname="delivery-filter-container"
              direction="left"
            />
            <AddressDropdown
              showId={false}
              selected={selectedAddress}
              onSelection={setSelectedAddress}
              addresses={skuAddressList}
              classname="delivery-filter-container"
            />
            <div className="xetgo-font-tag flex-row align-items-center gap-12 date-container px-8 py-4">
              {formatDate(startDate?.toISOString())}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={dayjs(startDate)}
                  format={"DD-MM-YYYY"}
                  views={["year", "month", "day"]}
                  onChange={startDateSelecttion}
                  open={startDateOpen}
                  className="delivery-date-selector"
                />
              </LocalizationProvider>
              <img
                src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240107114755-calendar-range.svg"
                onClick={toggleStartDate}
                className="cursor-pointer"
                height={16}
                width={16}
              />
            </div>
            <div className="date-container xetgo-font-tag flex-row align-items-center gap-12 px-8 py-4">
              {formatDate(endDate?.toISOString())}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={dayjs(endDate)}
                  format={"DD-MM-YYYY"}
                  views={["year", "month", "day"]}
                  onChange={endDateSelection}
                  open={endDateOpen}
                  className="delivery-date-selector"
                />
              </LocalizationProvider>
              <img
                src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240107114755-calendar-range.svg"
                onClick={toggleEndDate}
                className="cursor-pointer"
                height={16}
                width={16}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkuDeliveryFilter;
